/**
 * Key format of FlowVersion.dynamicPropertiesValues entries.
 * Written by the frontend prop resolvers and read back by the AI Builder
 * orchestrator — this helper is the single source of truth for the format.
 */
export const buildDynamicPropertiesKey = (params: {
    flowId: string
    pieceName: string
    stepName: string
    actionOrTriggerName: string
    propName: string
}): string =>
    `${params.flowId}_${params.pieceName}_${params.stepName}_${params.actionOrTriggerName}_${params.propName}`
